export const IUBENDA_CONSENT_EVENT = "iubenda-consent-updated";

declare global {
  interface Window {
    _iub?: {
      cs?: {
        api?: {
          isConsentGiven?: () => boolean;
          openPreferences?: () => void;
        };
      };
    };
  }
}

export function hasIubendaConsent(): boolean {
  if (typeof window === "undefined") return false;

  try {
    return !!window._iub?.cs?.api?.isConsentGiven?.();
  } catch {
    return false;
  }
}

export function waitForIubendaApi(callback: () => void, intervalMs = 500) {
  if (typeof window === "undefined") return () => undefined;

  if (window._iub?.cs?.api) {
    callback();
    return () => undefined;
  }

  const intervalId = window.setInterval(() => {
    if (!window._iub?.cs?.api) return;

    window.clearInterval(intervalId);
    callback();
  }, intervalMs);

  return () => window.clearInterval(intervalId);
}
